<template>
  <div class="CR">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img src="../assets/images/adidas.png" style="width: 160px; height: 37px; margin-top: 10px" />
      </a>
      <a href="#/ApprovalIndex" style="margin-top: 10px; margin-left: 30px; float: left">
        <img src="../assets/icon/back2.png" />
      </a>
    </div>
    <div class="content_title">
      <div class="d-flex d-flex-first">
        <div class="flex-item">
          <label class="label">POS Code</label>
          <el-input
            style="flex: 1; margin-left: 5px"
            v-model="POSCode"
            placeholder="Please input"
            type="textarea"
            rows="1"
            @keydown.enter.native="keyDown"
          ></el-input>
        </div>
        <div class="flex-item">
          <label class="label">Project Code</label>
          <el-input
            style="flex: 1; margin-left: 5px"
            v-model="ProjectCode"
            placeholder="Please input"
            type="textarea"
            rows="1"
            @keydown.enter.native="keyDown"
          ></el-input>
        </div>
        <div class="flex-item">
          <label class="label">POS Name</label>
          <el-input
            style="flex: 1; margin-left: 5px"
            v-model="POSName"
            placeholder="Please input"
            type="text"
          ></el-input>
        </div>
        <div class="flex-item">
          <label class="label">Team</label>
          <el-select
            v-model="Teams"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_Teams"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Teams.length !== TeamOptions.length"
              @change="selectAll_Teams"
            >All</el-checkbox>
            <el-option v-for="item in TeamOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>

        <div class="flex-item">
          <label class="label">Region</label>
          <el-select
            v-model="Regions"
            multiple
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
            @change="GetProvinces"
          >
            <el-checkbox
              v-model="check_Regions"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Regions.length !== RegionOptions.length"
              @change="selectAll_Regions"
            >All</el-checkbox>
            <el-option v-for="item in RegionOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">Province</label>
          <el-select
            v-model="Provinces"
            multiple
            collapse-tags
            placeholder="Please select"
            @change="GetCitys"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_Provinces"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Provinces.length !== ProvinceOptions.length"
              @change="selectAll_Provinces"
            >All</el-checkbox>
            <el-option
              v-for="item in ProvinceOptions"
              :key="item.id"
              :label="item.nameCN"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">City</label>
          <el-select
            v-model="Citys"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_Citys"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Citys.length !== CityOptions.length"
              @change="selectAll_Citys"
            >All</el-checkbox>
            <el-option
              v-for="item in CityOptions"
              :key="item.id"
              :label="item.nameCN"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">Action</label>
          <el-select
            v-model="Action"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_Action"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Action.length !== ActionOptions.length"
              @change="selectAll_Actions"
            >All</el-checkbox>
            <el-option v-for="item in ActionOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">Group Customer</label>
          <el-select
            v-model="GroupCustomers"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_GroupCustomers"
              style="margin-left: 20px; width: 200px"
              :indeterminate="
                GroupCustomers.length !== GroupCustomerOptions.length
              "
              @change="selectAll_GroupCustomers"
            >All</el-checkbox>
            <el-option v-for="item in GroupCustomerOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <div class="CR-btn">
        <el-button class="button-search" @click="search()">Search</el-button>
        <el-button class="button-search" @click="addCR()">Next</el-button>
      </div>
      <div class="cr-table">
        <div class="div-pagination">
          <el-pagination
            background
            @current-change="pagingChange"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :page-size="pagenum"
            :page-sizes="[20, 30,50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            ref="multipleTable"
          ></el-pagination>
        </div>
        <div class="table" ref="table">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="tableData"
            :header-cell-style="tableHeaderCell"
            :cell-style="tableCell"
            :height="tableHeight"
            border
            fit
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
          >
            <template>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                :prop="item.value"
                :label="item.label"
                v-for="(item, index) in tableColumn"
                :key="index"
                :width="item.width"
                show-overflow-tooltip
                :formatter="transferToDecimal"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <el-dialog title="" :visible.sync="dialogUploadVisible" width="50%" :close-on-click-modal="false"
          :destroy-on-close="true"  :show-close="false" style="text-align:left;">
          <div style="float: left;margin-top:-20px;">
            <p style="line-height: initial;font-size: medium;">{{Msg}}</p>
          </div>
          
          <div slot="footer" class="dialog-footer" style="margin-top:40px">
            <el-button type="primary" size="mini" @click="openUrl()">确定</el-button>        
          </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableColumn: [
        {
          label: "Project code",
          value: "projectCode",
          width: "250px"
        },
        {
          label: "POS Name",
          value: "posFullNameCN",
          width: "410px"
        },
        {
          label: "Format",
          value: "format",
          width: "auto"
        },
        {
          label: "Space",
          value: "space",
          width: "auto"
        },
        {
          label: "Team",
          value: "team",
          width: "auto"
        },
        {
          label: "Action",
          value: "action",
          width: "auto"
        },
        {
          label: "Support",
          value: "support",
          width: "auto"
        }
      ],
      total: 100,
      loading: false,
      currentPage: 1,
      pagenum: 20,
      tableHeight: window.innerHeight - 190,
      multipleSelection: [],
      POSCode: "",
      ProjectCode: "",
      Teams: [],
      TeamOptions: [],
      RegionOptions: ["East", "North", "South", "West"],
      Regions: [],
      POSCode: "",
      ProjectCode: "",
      ProvinceOptions: [],
      CityOptions: [],
      Provinces: [],
      Citys: [],
      POSName: "",
      Action: "",
      ActionOptions: [],
      GroupCustomers: [],
      GroupCustomerOptions: [],
      dialogUploadVisible:false,
      Msg:""
    };
  },
  computed: {
    check_Teams: {
      get() {
        if (this.Teams.length === this.TeamOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Provinces: {
      get() {
        if (this.Provinces.length === this.ProvinceOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Citys: {
      get() {
        if (this.Citys.length === this.CityOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Regions: {
      get() {
        if (this.Regions.length === this.RegionOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Action: {
      get() {
        if (this.Action.length === this.ActionOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_GroupCustomers: {
      get() {
        if (this.GroupCustomers.length === this.GroupCustomerOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    }
  },
  created() {
    this.GetTeam();
    this.GetCRAction();
    this.GetGroupCustomer();
  },
  methods: {
    tableHeaderCell({ column }) {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell({ column }) {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    pagingChange(pageIndex) {
      this.BindData(pageIndex);
    },
    handleSizeChange(val) {
      this.pagenum = val;
      this.BindData(this.currentPage);
    },
    BindData(pageIndex) {
      var provinces = [];
      var citys = [];
      if (this.Provinces.length > 0) {
        this.Provinces.forEach(element => {
          provinces.push(this.ProvinceOptions.find(p => p.id == element));
        });
      }
      if (this.Citys.length > 0) {
        this.Citys.forEach(element => {
          citys.push(this.CityOptions.find(p => p.id == element));
        });
      }

      this.currentPage = pageIndex;
      this.loading = true;
      this.$api
        .post("/CR/GetCrProject", {
          currentpage: pageIndex,
          page: this.pagenum,
          posCode: this.POSCode,
          projectCode: this.ProjectCode,
          posName: this.POSName,
          teams: this.Teams,
          regions: this.Regions,
          provinces: provinces,
          citys: citys,
          actions: this.Action,
          groupCustomers: this.GroupCustomers
        })
        .then(res => {
          if (res.data.status == true) {
            this.tableData = res.data.content;
            this.total = res.data.total;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          }
          this.loading = false;
        });
    },
    Init() {
      this.checkUnitCost();
      this.BindData(1);
    },
    transferToDecimal(row,column) {
        let cellvalues = row[column.property];
        if (typeof cellvalues === "number") {
          cellvalues = parseFloat(cellvalues).toFixed(2);
          let [sInt, sFloat] = cellvalues.toString().split(".");
          sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
          return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
      } else {
        return cellvalues;
      }
    },
    getMaxLength(arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          let c = this.getTextWidth(item);
          if (acc < c) {
            acc = c;
          }
        }
        return acc;
      }, 0);
    },
    getTextWidth(str) {
      let width = 0;
      const html = document.createElement("span");
      html.innerText = str;
      html.className = "getTextWidth";
      document.querySelector("body").appendChild(html);
      width = document.querySelector(".getTextWidth").offsetWidth;
      document.querySelector(".getTextWidth").remove();
      return width;
    },
    flexColumnWidth(label, prop) {
      const arr = this.tableData.map(x => x[prop]);
      arr.push(label);
      return this.getMaxLength(arr) + 20 + "px";
    },
    handleSelectionChange(val) {
      console.log(val, "12");
      this.multipleSelection = val;
    },
    addCR() {
      // console.log(this.multipleSelection);
      let applications =
        this.multipleSelection.map(c => {
          return c.application;
        }) || [];
      // if (!applications.length) {
      //   this.$message({
      //     type: "error",
      //     message: "至少选择一个"
      //   });
      //   return;
      // }
      sessionStorage.setItem("Cr_Ids", JSON.stringify({ ID: applications }));
      this.$router.push({
        name: "CRMangeAdd",
        params: {
          ID: applications
        }
      });
    },
    category() {
      this.$router.push({
        name: "UnitCostMaintanance"
      });
    },
    bigTable() {
      this.$router.push({
        name: "ProjectDatabase"
      });
    },
    search() {
      let params = {
        POSCode: "",
        ProjectCode: "",
        POSName: "",
        Teams: [],
        Regions: [],
        Provinces: [],
        Citys: [],
        Action: []
      };
      this.BindData(1);
    },
    keyDown(e) {
      debugger;
      if (e.ctrlKey && e.keyCode == 13) {
        //用户点击了ctrl+enter触发
        this.search();
      }
    },
    GetCRAction() {
      this.$api
        .get("/CR/GetCRAction", {}, res => {})
        .then(res => {
          if (res.data.status) {
            this.ActionOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    GetGroupCustomer() {
      this.$api
        .get("/Task/GetGroupCustomer", {}, res => {})
        .then(res => {
          if (res.data.status) {
            this.GroupCustomerOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    GetTeam() {
      this.$api
        .get("/Task/GetTeam", {}, res => {})
        .then(res => {
          if (res.data.status) {
            this.TeamOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    GetProvinces() {
      if (this.Regions.length > 0) {
        this.$api
          .post("/Task/GetProvinces", { strs: this.Regions }, res => {})
          .then(res => {
            if (res.data.status) {
              this.ProvinceOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          });
      } else {
        this.ProvinceOptions = [];
        this.Provinces = [];
        this.CityOptions = [];
        this.Citys = [];
      }
    },
    GetCitys() {
      if (this.Provinces.length > 0) {
        this.$api
          .post("/Task/GetCitys", { ids: this.Provinces }, res => {})
          .then(res => {
            if (res.data.status) {
              this.CityOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          });
      } else {
        this.CityOptions = [];
        this.Citys = [];
      }
    },
    selectAll_Teams(checked) {
      if (checked) {
        this.Teams = this.TeamOptions.map(d => d);
      } else {
        this.Teams = [];
      }
    },
    selectAll_Provinces(checked) {
      if (checked) {
        this.Provinces = this.ProvinceOptions.map(d => d.id);
      } else {
        this.Provinces = [];
      }
      this.GetCitys();
    },
    selectAll_Citys(checked) {
      if (checked) {
        this.Citys = this.CityOptions.map(d => d.id);
      } else {
        this.Citys = [];
      }
    },
    selectAll_Actions(checked) {
      if (checked) {
        this.Action = this.ActionOptions.map(d => d.id);
      } else {
        this.Action = [];
      }
    },
    selectAll_Regions(checked) {
      if (checked) {
        this.Regions = this.RegionOptions.map(d => d);
      } else {
        this.Regions = [];
      }
      this.GetProvinces();
    },
    selectAll_GroupCustomers(checked) {
      if (checked) {
        this.GroupCustomers = this.GroupCustomerOptions.map(d => d);
      } else {
        this.GroupCustomers = [];
      }
    },
    checkUnitCost()
    {
      this.$api
        .get("/CR/GetUnitCostCount", {}, res => {})
        .then(res => {
          if (res.data.status) {
            if(res.data.content!="")
            {
              this.Msg="系统中"+res.data.content+"对应的Unit Cost为空，请先到Unit Cost页面维护数据，之后才能提交CR";
              this.dialogUploadVisible=true;
              // this.$message({
              // type: "error",
              // message: "系统中Format1，Format2 …对应的Unit Cost为空，请先到Unit Cost页面维护数据，之后才能提交CR"
             //});
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    openUrl(){
      window.open("#/UnitCostMaintanance", "_self");
    }

  },
  mounted() {
    this.Init();
  }
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.d-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: left;
  margin: auto;
  width: 94%;
  &.d-flex-first {
    margin-top: 30px;
  }
  .flex-item {
    width: 25%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 10px;

    overflow: hidden;
    margin-bottom: 15px;
    .label {
      padding-right: 5px;
      min-width: 120px;
      text-align: right;
    }
    &:nth-child(4n-3) {
      padding-left: 0;
    }
  }
}
.content_title {
  margin: 10px auto 0;
  width: 90%;
  text-align: left;
  .CR-btn {
    display: flex;
    justify-content: end;
    .button-search {
      background-color: #e6a23c;
      border: 0px #e6a23c;
      color: #ffff;
    }
  }
}
.cr-table {
  width: 100%;

  .div-pagination {
    text-align: right;
    margin-bottom: 10px;
    display: inline-block;
    width: 100%;
    padding-top: 10px;
  }
}

::v-deep.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    //text-align: center;
    white-space: normal;
    left:25%;
    top:-10%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CR.vue